// This slice will be used to managed the worker jobsites state. 
// Fetched jobsites will be stored in the state, and the slice will handle actions performed by workers on jobsites. 

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import employerJobsitesService from "./employerJobsitesService";

const initialState = {
    jobsites: [], 
    isError: null,
    isSuccess: null,
    isLoading: null,
    message: null,
};

//Create new worker 
export const getEmployerJobsites = createAsyncThunk('employerJobsites/getAll', 
    async( _, thunkAPI) =>{

        try {
            const token = thunkAPI.getState().workerAuth.workerUser.webToken;
            return await employerJobsitesService.getEmployerJobsites(token)
        } catch (error) {
            const message = 
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
            console.log(message)
                return thunkAPI.rejectWithValue('Failed to create worker')
        }
})


export const employerJobsitesSlice = createSlice ({
    name: 'employerJobsites',
    initialState,
    reducers:{

        resetEmployerJobsites: (state) => {
            return initialState; // No need to preserve selectedWorker anymore
        },
        
        
    },
    extraReducers : (builder) => {
        builder 
            .addCase(getEmployerJobsites.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getEmployerJobsites.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.jobsites = action.payload;
            })
            .addCase(getEmployerJobsites.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Failed to fetch jobsites';
            });
    }
    });



export const { resetEmployerJobsites } = employerJobsitesSlice.actions
export default employerJobsitesSlice.reducer